<template>
    <div style="width: 100%">
        <employee-table></employee-table>
    </div>
</template>

<script>
    const employeeTable  = () => import( '@/components/orgApps/Employee/EmployeeTable');
    
    export default {
        name: "dashboard",
        components:{
            employeeTable
        },
        data() {
            return { };
        },
        watch:{
            filters: {
                deep: true
            }
        },
        methods:{
            initialize() {
                
            }
        },
        async created(){
            this.initialize()
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>